import { MaterialUICore, TextField } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const SignupField = styled(TextField)(() => ({
  marginBottom: 0,
}));
